import { render, staticRenderFns } from "./SmsGroups.vue?vue&type=template&id=bb07b716"
import script from "./SmsGroups.vue?vue&type=script&lang=js"
export * from "./SmsGroups.vue?vue&type=script&lang=js"
import style0 from "./SmsGroups.vue?vue&type=style&index=0&id=bb07b716&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports